/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ProgressManagerSeekEvent extends alm.event.Event {

		public static SEEK:string = "ProgressManagerSeekEvent.SEEK";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, ratio:number) {
			super(eventType, target);
			this.ratio = ratio;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getRatio():number {
			return this.ratio;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private ratio:number;
	}
}
